<template>
  <div class="list-page">
    <crumbs title="选择活动推荐">
      <template v-slot:close>
        <div class="close" @click="$router.go(-1)">
          <i class="el-icon-circle-close"></i>
        </div>
      </template>
    </crumbs>
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="4">
          <enumerate
            url="/api/news/acttypeenum"
            v-model="queryCondition.actType"
            placeholder="活动信息类别"
          />
        </el-col>
        <el-col :span="4">
          <enumerate
            url="/api/news/actformenum"
            v-model="queryCondition.actForm"
            placeholder="组织形式"
          />
        </el-col>
        <!-- <el-col :span="4">
          <enumerate
            url="/api/news/getactivityrecommendstatusenum"
            v-model="queryCondition.activityRecommendStatus"
            placeholder="推荐状态"
          />
        </el-col> -->
        <el-col :span="4">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="发布开始时间"
            end-placeholder="发布结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="10">
          <el-input
            v-model="queryCondition.keyWord"
            clearable
            placeholder="搜索活动标题"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column
          prop="title"
          label="活动标题"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="actTypeName"
          label="类型"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="actFormName"
          label="组织形式"
          align="center"
          width="90"
        >
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="活动状态"
          align="center"
          width="90"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="isFirstPageRecommendName"
          label="推荐状态"
          align="center"
          width="90"
        >
        </el-table-column> -->
        <el-table-column
          prop="viewCount"
          label="浏览量"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="memberCount"
          label="报名人数"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="结束时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.endTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.endTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>

        <el-table-column label="发布时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleChoice(scope.row)"
              >选择</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "recommendAct",
  data() {
    return {
      apiUrl: [],
      //查询条件
      queryCondition: {
        isRecommendPage: 1,
        actType: "",
        actForm: "",
        activityStatus: "",
        activityRecommendStatus: "",
        publishDate: [],
        keyWord: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: []
    };
  },
  created() {
    const { method } = this.$route.query;
    let apiUrl;
    switch (method) {
      case "keyword":
        apiUrl = ["addKeywordRecommend", "getKeywordAct"];
        break;
      case "homepage":
        apiUrl = ["addHomepageRecommend", "getHomepageAct"];
        break;
    }
    this.apiUrl = apiUrl;
    this.loadList();
  },
  methods: {
    handleChoice(row) {
      const { id, title } = row;
      const { type, relationType } = this.$route.query;
      this.isLoading = true;
      this.$api("recommend", this.apiUrl[0], {
        relationId: id,
        name: title,
        type,
        relationType
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$router.go(-1);
        }
      });
    },
    //出来参数
    processParams() {
      let { keyWord, pageIndex, pageSize, publishDate } = this.queryCondition,
        mixin = {
          actType: "",
          actForm: "",
          activityStatus: "",
          activityRecommendStatus: ""
        },
        [createStart = "", createEnd = ""] = publishDate || [];

      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWord,
        pageIndex,
        pageSize,
        ...mixin,
        createStart,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("recommend", this.apiUrl[1], this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
